import { Marketer, ServerMarketer, ServerMarketerAccess } from '../../typings/marketers';

export const mapInternalMarketerFromApi = (marketer: ServerMarketer): Marketer => ({
    id: String(marketer.clientId),
    login: marketer.productLogin,
    fullName: marketer.username,
    ownProducts: marketer.availableProducts.map(product => ({
        id: String(product.productId),
        productName: product.productName,
        productLogin: product.productLogin,
        access: mapInternalMarketerAccessTypeFromApi(product.accessType, product.placeIds),
        placeIds: product.placeIds || [],
        isSaved: true,
        isRemoving: false
    }))
});

export const mapInternalMarketerAccessTypeFromApi = (
    accessType: ServerMarketerAccess,
    placeIds: number[]
): ServerMarketerAccess =>
    accessType === ServerMarketerAccess.FULL && placeIds && placeIds.length > 0
        ? ServerMarketerAccess.BY_PLACE
        : accessType;
